module.exports = __webpack_public_path__ + "static/media/instructivoac9.81916aa7.png";